<script lang="ts">
    // No props needed — purely presentational brand panel
</script>

<div class="hidden lg:flex flex-col h-full min-h-screen bg-gradient-to-br from-xerteal-700 via-xerteal-600 to-xerteal-500 text-white relative overflow-hidden">
    <!-- Background hero image -->
    <img
        src="/assets/images/group_ride_dolomites.jpg"
        alt=""
        aria-hidden="true"
        class="absolute inset-0 w-full h-full object-cover opacity-20"
    />

    <!-- Content -->
    <div class="relative z-10 flex flex-col h-full justify-between p-10">
        <!-- Logo -->
        <div>
            <img
                src="/assets/images/logos/XertLogosV3/Xert%20V3%20Logo%20-%20White.svg"
                alt="Xert"
                class="h-8"
            />
        </div>

        <!-- Tagline -->
        <div class="space-y-6">
            <h1 class="text-4xl font-bold leading-tight tracking-tight">
                Discover.<br/>Improve.<br/>Perform.
            </h1>
            <p class="text-xerteal-100 text-lg max-w-xs leading-relaxed">
                The most innovative endurance training platform. Manage your training, analyse your results, and reach new levels of performance.
            </p>
            <div class="flex items-center gap-3 text-sm text-xerteal-200">
                <span class="flex items-center gap-1.5">
                    <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>
                    No FTP tests
                </span>
                <span class="flex items-center gap-1.5">
                    <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>
                    Real-time feedback
                </span>
                <span class="flex items-center gap-1.5">
                    <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>
                    Free 30-day trial
                </span>
            </div>
        </div>

        <!-- Footer -->
        <div class="text-xerteal-300 text-xs">
            © {new Date().getFullYear()} Baron Biosystems Ltd.
        </div>
    </div>
</div>
